import Vue from 'vue';
import moment from 'moment';
import cookie from '../../cookie/cookie';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'contractAgreement',
    props: {
        agreementData: {
            type: Object,
            default: function () {
                return {
                    isTemplate: true,
                    capitalName: 'XXX',
                    contractCode: 'XX',
                    tenantName: 'XX',
                    startTime: 'YYYY-MM-DD',
                    endTime: 'YYYY-MM-DD',
                    totalAmount: 'XX',
                    totalDuration: 'XX',
                    capitalRepayPlanQueryDTOList: [
                        {
                            planAmount: 'XX',
                            deductMode: '日扣优先',
                            startTime: 'XX',
                            endTime: 'XX',
                        },
                        {
                            planAmount: 'XX',
                            deductMode: '日扣优先',
                            startTime: 'XX',
                            endTime: 'XX',
                        },
                    ],
                };
            },
        },
    },
    data: function () {
        return {
            usernameZh: '',
            planTotalAmount: 0,
            planTotalDate: '',
            currentAgreement: {},
        };
    },
    created: function () {
        this.currentAgreement = Object.assign({}, this.agreementData);
        this.getUserName();
        this.init();
    },
    watch: {
        agreementData: function (val) {
            this.currentAgreement = Object.assign({}, val);
            this.init();
        },
    },
    methods: {
        init: function () {
            var _this = this;
            if (this.currentAgreement.isTemplate) {
                this.planTotalAmount = 'XX';
                this.planTotalDate = 'YYYY-MM-DD 至 YYYY-MM-DD';
                return;
            }
            var _a = this.currentAgreement, startTime = _a.startTime, endTime = _a.endTime, totalAmount = _a.totalAmount;
            this.currentAgreement = Object.assign(this.currentAgreement, {
                startTime: startTime ? moment(startTime).format('YYYY-MM-DD') : '--',
                endTime: endTime ? moment(endTime).format('YYYY-MM-DD') : '--',
                totalAmount: totalAmount ? toYuan(totalAmount).toFixed(2) : '--',
            });
            if (!this.currentAgreement.capitalRepayPlanQueryDTOList ||
                this.currentAgreement.capitalRepayPlanQueryDTOList.length === 0) {
                return;
            }
            var len = this.currentAgreement.capitalRepayPlanQueryDTOList.length;
            var planTotalAmount = 0;
            var planStartTime = '';
            var planEndTime = '';
            this.currentAgreement.capitalRepayPlanQueryDTOList.forEach(function (item, index) {
                var planAmount = item.planAmount, startTime = item.startTime, endTime = item.endTime, deductMode = item.deductMode;
                planTotalAmount += +planAmount;
                if (index === 0) {
                    planStartTime = moment(startTime).format('YYYY-MM-DD');
                }
                if (index === len - 1) {
                    planEndTime = moment(endTime).format('YYYY-MM-DD');
                }
                item = Object.assign(item, {
                    planAmount: planAmount ? toYuan(planAmount).toFixed(2) : '--',
                    startTime: startTime
                        ? moment(startTime).format('YYYY-MM-DD')
                        : '--',
                    endTime: endTime ? moment(endTime).format('YYYY-MM-DD') : '--',
                    deductMode: _this.deduct(deductMode),
                });
            });
            this.planTotalAmount = toYuan(planTotalAmount).toFixed(2);
            this.planTotalDate = planStartTime + " \u81F3 " + planEndTime;
        },
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        changeDate: function (value) {
            return moment(value).format('YYYY-MM-DD');
        },
        deduct: function (val) {
            var deduct = {
                DAILY_DEDUCT_AVG: '日扣平均',
                DAILY_DEDUCT_PRIOR: '日扣优先',
            };
            return deduct[val] || '--';
        },
        signAgreement: function () {
            var _this = this;
            var _a = this.currentAgreement, capitalCode = _a.capitalCode, contractCode = _a.contractCode;
            this.$request({
                url: '/proxy/fund-api/capital/contract/payment/agreement/sign',
                method: 'post',
                data: {
                    capitalCode: capitalCode,
                    contractCode: contractCode,
                    operator: this.usernameZh,
                },
            }).then(function (res) {
                if (!res || res.errorCode !== 0) {
                    return;
                }
                _this.$message({
                    type: 'success',
                    message: '当前协议签署成功',
                });
                _this.$store.dispatch('common/GET_UNSIGNLIST');
            });
        },
    },
});
